export const getContent = (t: Function) => [
  {
    modificator: 'ipo',
    text: [t('IPO tab paragraph 1'), t('IPO tab paragraph 2'), t('IPO tab paragraph 3')],
    textWidth: 356,
    caption: t('IPO tab caption'),
    graph: [
      {
        year: 2015,
        bigColumn: true,
        height: 56,
      },
      {
        year: 2016,
        bigColumn: true,
        height: 280,
      },
      {
        year: 2017,
        bigColumn: true,
        height: 154,
      },
      {
        year: 2018,
        bigColumn: true,
        height: 161,
      },
      {
        year: 2019,
        bigColumn: true,
        height: 280,
      },
    ],
    popupText: t('Results for three months Commissions are taken into account'),
    popup: [
      {
        title: 2015,
        subitems: [
          { title: 'Fitbit', value: 82, height: 18 },
          { title: 'Planet Fitness', value: -9, height: 20 },
          { title: 'Ferrari', value: -26, height: 21 },
          { title: 'Square', value: 13, height: 18 },
          { title: 'Match Group', value: -18, height: 15 },
        ],
      },
      {
        title: 2016,
        subitems: [
          { title: 'Editas Medicine', value: 66, height: 17 },
          { title: 'Corvus Pharma', value: -15, height: 19 },
          { title: 'BA Tobacco', value: 28, height: 24 },
          { title: 'US Foods Holding', value: 6, height: 18 },
          { title: 'Twilio', value: 247, height: 19 },
          { title: 'Line Corporation', value: 30, height: 20 },
          { title: 'Nutanix', value: 51, height: 13 },
          { title: 'Coupa', value: 25, height: 21 },
          { title: 'ZTO Express', value: -42, height: 10 },
          { title: 'Trivago', value: 8, height: 11 },
        ],
      },
      {
        title: 2017,
        subitems: [
          { title: 'Snapchat', value: 19, height: 20.77 },
          { title: 'MuleSoft', value: 35, height: 20.77 },
          { title: 'Okta', value: 27, height: 16 },
          { title: 'Cloudera', value: 12, height: 22 },
          { title: 'Blue Apron', value: -55, height: 20 },
          { title: 'Tintri', value: -62, height: 20 },
          { title: 'Roku', value: 211, height: 10 },
          { title: 'Switch', value: 4, height: 16 },
          { title: 'CarGurus', value: 70, height: 16 },
          { title: 'Qudian', value: -54, height: 24 },
          { title: 'MongoDB Inc', value: 16, height: 27 },
          { title: 'ForeScout', value: 37, height: 11 },
        ],
      },
      {
        title: 2018,
        subitems: [
          { title: 'ADT Corporation', value: -39, height: 20.77 },
          { title: 'PagSeguro', value: 42, height: 11.18 },
          { title: 'PlayAGS', value: 31, height: 12.78 },
          { title: 'FTS International', value: 6, height: 20.77 },
          { title: 'BioXcel', value: -15, height: 17.58 },
          { title: 'Zscaler', value: 105, height: 15.98 },
          { title: 'Dropbox', value: 32, height: 20.77 },
          { title: 'Zuora', value: 72, height: 9.59 },
          { title: 'DocuSign', value: 59, height: 14.38 },
          { title: 'Smartsheet', value: 38, height: 25.56 },
          { title: 'Carbon Black', value: 26, height: 20.77 },
          { title: 'Pluralsight', value: 82, height: 19.17 },
          { title: 'GreenSky', value: -22, height: 20.77 },
          { title: 'Avalara', value: 59, height: 19.97 },
          { title: 'Xiaomi', value: -25, height: 20.77 },
          { title: 'Tenable', value: 21, height: 22.37 },
          { title: 'ARLO', value: -23, height: 15.98 },
          { title: 'Eventbrite', value: 13, height: 24 },
          { title: 'Farfetch', value: -18, height: 25 },
          { title: 'Elastic', value: 84, height: 22 },
          { title: 'Anaplan', value: 47, height: 22 },
          { title: 'SolarWinds', value: 19, height: 22 },
          { title: 'Acreage Holdings', value: -35, height: 22 },
          { title: 'Babytree Group', value: 5, height: 22 },
          { title: 'Tencent Music', value: 29, height: 18 },
          { title: 'Luckin coffee', value: 13, height: 22 },
        ],
      },
      {
        title: 2019,
        subitems: [
          { title: 'Levi`s', value: 20, height: 18.94 },
          { title: 'Lyft', value: -15, height: 21 },
          { title: 'Silk Road', value: 87, height: 21 },
          { title: 'PagerDuty', value: 80, height: 21 },
          { title: 'Tufin', value: 90, height: 17 },
          { title: 'Zoom', value: 121, height: 10.48 },
          { title: 'Pinterest', value: 27, height: 21 },
          { title: 'Beyond Meat', value: 453, height: 21.06 },
          { title: 'TransMedics', value: 28, height: 21 },
          { title: 'Yunji', value: -17, height: 21 },
          { title: 'Fastly', value: 8, height: 22.57 },
          { title: 'Revolve', value: 18, height: 21 },
          { title: 'CrowdStrike', value: 76, height: 16.85 },
          { title: 'Fiverr', value: -11, height: 21 },
          { title: 'Chewy', value: 29, height: 15 },
          { title: 'Adaptive Biotech', value: 38, height: 22.37 },
          { title: 'The RealReal', value: 5, height: 18 },
          { title: 'DoYou', value: -40, height: 21 },
          { title: 'Medallia', value: 17, height: 21 },
          { title: 'Health Catalyst', value: 11, height: 21 },
          { title: 'Livongo Health', value: -28, height: 21 },
          { title: 'Dynatrace', value: 26, height: 21 },
          { title: 'Sundial Growers', value: -80, height: 21 },
          { title: 'InMode', value: 143, height: 21 },
          { title: 'SmileDirectClub', value: -71, height: 18 },
          { title: 'Cloudflare', value: 16, height: 21 },
          { title: 'Datadog', value: 33, height: 21 },
          { title: 'Ping Identity', value: 46, height: 21 },
          { title: 'Peloton Interactive', value: 3, height: 21 },
          { title: 'Progyny', value: 112, height: 21 },
          { title: 'Bill', value: 40, height: 21 },
          { title: 'Sprout Social', value: -14, height: 21 },
        ],
      },
    ],
  },
  {
    modificator: 'pre-ipo',
    text: [
      t('PRE-IPO tab paragraph 1'),
      t('PRE-IPO tab paragraph 2'),
      t('PRE-IPO tab paragraph 3'),
      t('PRE-IPO tab paragraph 4'),
      t('PRE-IPO tab paragraph 5'),
    ],
    textWidth: 442,
    caption: t('PRE-IPO tab caption'),
    graph: [
      {
        year: 2015,
        bigColumn: false,
        height: 70,
      },
      {
        year: 2015,
        bigColumn: false,
        height: 70,
      },
      {
        year: 2016,
        bigColumn: false,
        height: 56,
      },
      {
        year: 2016,
        bigColumn: false,
        height: 98,
      },
      {
        year: 2017,
        bigColumn: false,
        height: 105,
      },
      {
        year: 2017,
        bigColumn: false,
        height: 189,
      },
      {
        year: 2018,
        bigColumn: false,
        height: 126,
      },
      {
        year: 2018,
        bigColumn: false,
        height: 287,
      },
      {
        year: 2019,
        bigColumn: false,
        height: 112,
      },
      {
        year: 2019,
        bigColumn: false,
        height: 259,
      },
    ],
    nonClickable: true,
  },
];

export const PRE_IPO_PNL = [10, 10, 8, 14, 15, 27, 18, 41, 16, 37];
